export default __webpack_public_path__ + "static/media/esdm.2307c247.png";